<template>
	<div class="profile">
		<img
			v-if="!isShowProfileMenu || !isSmallDevice"
			:src="imgProfile"
			:alt="user.data.displayName"
			class="profile-img"
			@click="toggleProfileMenu"
		/>
		<span
			v-else
			:aria-label="$t('WordscapesLevelPageClearAriaLabel')"
			class="clear"
			@click="toggleProfileMenu"
		/>
		<div v-if="isShowProfileMenu" class="profile-overlay">
			<div v-click-outside="clickOutside" class="profile-menu">
				<div class="top">
					<img
						:src="imgProfile"
						width="56"
						height="56"
						:alt="user.data.displayName"
					/>
					<div class="info">
						<div class="name">
							{{
								$t("LoginMenuTextUsername", {
									GmailUserName: user.data.displayName,
								})
							}}
						</div>
						<div class="email">
							{{
								$t("LoginMenuTextUserEmail", {
									GmailEmail: user.data.email,
								})
							}}
						</div>
					</div>
				</div>
				<ul class="items">
					<li>
						<a
							href="#"
							:title="$t('LoginMenuTitleAttributeSignOut')"
							class="item-link"
							@click.prevent="onLogout"
						>
							<img
								src="@/assets/images/logout.svg"
								width="22"
								height="22"
								alt="Logout"
								class="icon"
							/>
							{{ $t("LoginMenuTextSignOut") }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
	name: "Profile",
	directives: {
		ClickOutside,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		imgProfile: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			isShowProfileMenu: false,
		};
	},
	methods: {
		toggleProfileMenu() {
			this.isShowProfileMenu = !this.isShowProfileMenu;

			if (!this.isSmallDevice) return;
			const body = document.getElementsByTagName("body")[0];
			this.isShowProfileMenu
				? (body.style.overflow = "hidden")
				: (body.style.overflow = null);
		},
		clickOutside(e) {
			if (
				this.isShowProfileMenu &&
				!["profile-img", "clear"].includes(e.target.className)
			) {
				this.toggleProfileMenu();
			}
		},
		onLogout() {
			this.$emit("logout");
			this.toggleProfileMenu();

			this.$store.dispatch("trackEvent", {
				eventCategory: "Login",
				eventAction: "Click on sign out menu section",
				eventLabel: "LoginMenuTextSignOut",
			});
		},
	},
};
</script>
<style lang="scss" src="./styles.scss" scoped></style>
